(ns io.repliance.schemas.organization
  (:require
   [clojure.walk :as walk]
   [io.repliance.schemas.core :as schemas]
   [malli.util :as mu]))

(defn build-tree
  "Accepts a vector of maps and, according to their reports-to-person-id, will
   nest the list into a tree that represents the org. hierarchy"
  [nodes]
  (let [add-child
        (fn add-child [{:keys [person-id] :as node}]
          (let [children (filter
                           #(= (:reports-to-person-id %) person-id)
                           nodes)]
            (assoc node :reports (map add-child children))))]
    (->> nodes
         (remove :reports-to-person-id)
         (map add-child))))

(defn collect-reports-ids
  "Walks a node in the organizational tree to collect the IDs of all of the
   members of the :reports tree structure. Returns a list of IDs of all
   persons who report to the given node."
  [data]
  (->> data
       (walk/postwalk
        (fn [node]
          (if (and (map? node) (:person-id node))
            [(:person-id node) (:reports node)]
            node)))
       flatten
       set))

(def Person
  [:map
   [:person-id :int]
   [:revision {:optional true} [:maybe :int]]
   [:fullname schemas/NonBlankString]
   [:title :string]
   [:is-active {:optional true} :boolean]
   [:reports-to-person-id [:maybe :int]]
   [:start-ts {:optional true} [:maybe schemas/Instant]]
   [:end-ts {:optional true} [:maybe schemas/Instant]]])

(def NewPerson
  (-> Person
      (mu/dissoc :person-id)
      (mu/dissoc :revision)
      ;; Make :reports-to-person-id optional
      (mu/merge [:map
                 [:reports-to-person-id {:optional true} [:maybe :int]]])))

(def PersonRevision
  [:map
   [:person-id :int]
   [:revision :int]
   [:is-canonical :boolean]
   [:saved-ts schemas/Instant]
   [:author :string]
   [:fullname schemas/NonBlankString]
   [:title :string]
   [:is-active :boolean]
   [:reports-to-person-id [:maybe :int]]
   [:start-ts {:optional true} [:maybe schemas/Instant]]
   [:end-ts {:optional true} [:maybe schemas/Instant]]])

(def person-asa-responsibility-schema
  [:map
   [:version-id :uuid]])
